import { dateMapper } from '../mappers/date.mapper';

/** Base included product. */
export class BaseIncludedProduct {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.unitPrice = data.unitPrice;
  }
}

/** Included product. */
export class IncludedProduct extends BaseIncludedProduct {
  constructor(data) {
    super(data);
    this.code = data.code;
    this.typeId = data.typeId;
    this.editDate = dateMapper.fromDto(data.editDate);
  }
}

/** Included product. */
export class PackageIncludedProduct extends BaseIncludedProduct {
  constructor(data) {
    super(data);
    this.description = data.description;
  }
}
